import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';
import { BI_BASE_URL } from '@app/contstants/endpoints';

interface IAccountFilter {
  id: number;
  account: string;
}

/** Поиск ViaBTC-аккаунтов через BI `helpers/search/accounts/`. */
export async function searchAccounts(account_query: string): Promise<ISelectOption[]> {
  const response = await api.get<IAccountFilter[]>(`${BI_BASE_URL}/helpers/search/accounts/`, {
    params: {
      account_query: account_query ?? '',
    },
  });
  const data = response.data ?? [];

  return data.map(item => ({
    value: item.account,
    label: item.account,
  }));
}

export const fetchData = async (): Promise<ISelectOption[]> => searchAccounts('');

export const useAccountOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchData,
    onError: error => errorHandler(error),
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
